import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Код версии контроля',
    key: 'ctrl_vers_code',
    width: 250,
    fixedLeft: true,
  },
  {
    title: 'Код контроля',
    key: 'ctrl_code',
    width: 250,
  },
  {
    title: 'Номер версии',
    key: 'version_num_out',
    width: 250,
  },
  {
    title: 'Дата с',
    key: 'date_from',
    width: 250,
  },
  {
    title: 'Дата по',
    key: 'date_to',
    width: 250,
  },
  {
    title: 'Внешний код версии контроля',
    key: 'ctrl_vers_ext',
    width: 250,
  },
  {
    title: 'Описание контроля',
    key: 'ctrl_vers_desc',
    width: 250,
  },
  {
    title: 'Описание статуса (успех)',
    key: 'text_success',
    width: 250,
  },
  {
    title: 'Описание статуса (расхождение)',
    key: 'text_fail',
    width: 250,
  },
];
